module.exports = __webpack_public_path__ + "img/penthouse-l.fe79e4ec.jpg";